import * as React from "react";
const SvgEditorChoice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="m12 21-3.375 1.125a3 3 0 0 1-.325.075q-.15.025-.3.025-.8 0-1.4-.562T6 20.225v-5.45L3.4 10.55a2.1 2.1 0 0 1-.225-.513 1.95 1.95 0 0 1 0-1.075Q3.25 8.7 3.4 8.45l3.4-5.5q.275-.45.725-.7T8.5 2h7a1.98 1.98 0 0 1 1.7.95l3.4 5.5q.15.25.225.513a1.95 1.95 0 0 1 0 1.075q-.075.262-.225.512L18 14.775v5.45q0 .875-.6 1.438a1.98 1.98 0 0 1-1.7.537 3 3 0 0 1-.325-.075zm0-2.1 4 1.325V17H8v3.225zM8.5 15h7l3.4-5.5L15.5 4h-7L5.1 9.5zm2.45-4.25 3.525-3.55a.86.86 0 0 1 .688-.288q.412.014.712.288.3.3.313.712a.93.93 0 0 1-.288.713l-4.25 4.25q-.3.3-.7.3a.96.96 0 0 1-.7-.3L8.125 10.75q-.3-.3-.3-.713 0-.412.3-.712t.712-.3.713.3z"
    />
  </svg>
);
export default SvgEditorChoice;
